import { createContext, useContext, type ReactNode } from "react";
import type { DtoolsStagingLine } from "@shared/dtoolsJsonStaging";

export type DtoolsReviewLineActionsValue = {
  lines: DtoolsStagingLine[];
  onLinesChange: (lines: DtoolsStagingLine[]) => void;
};

const DtoolsReviewLineActionsContext = createContext<DtoolsReviewLineActionsValue | null>(null);

export function DtoolsReviewLineActionsProvider({
  value,
  children,
}: {
  value: DtoolsReviewLineActionsValue;
  children: ReactNode;
}) {
  return <DtoolsReviewLineActionsContext.Provider value={value}>{children}</DtoolsReviewLineActionsContext.Provider>;
}

export function useDtoolsReviewLineActions(): DtoolsReviewLineActionsValue | null {
  return useContext(DtoolsReviewLineActionsContext);
}
